/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { domainsControllerCreate } from "./domainsControllerCreate";
import { domainsControllerFindAll } from "./domainsControllerFindAll";
import { domainsControllerRemove } from "./domainsControllerRemove";

export function domainsService() {
  return { domainsControllerFindAll, domainsControllerCreate, domainsControllerRemove }
}